import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface UseUpdateDoc {
  field: string;
  value: string | boolean | null;
  docId: string;
  matterId: string;
}

const useUpdateDoc = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(async ({ field, value, docId, matterId }: UseUpdateDoc) => {
    const fetchConfig = getFetchConfig({ method: FetchMethod.PATCH, data: { [field]: value } });
    return fetch(`${APIBaseChronos}/api/matter/${matterId}/docs/${docId}`, fetchConfig)
      .then((res) => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetDocs, { matterId }] });
        if (field === 'type') {
          queryClient.invalidateQueries({ queryKey: [QueryEntity.DocTypes, { matterId }] });
        }

        return res.json();
      })
      .catch((err) => {
        toast.error('Failed to update field');
      });
  });
};

export default useUpdateDoc;
